/* Modern Mercy: welcome discount popup intentionally disabled for the cleaner conversion test. */
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-mm-welcome]').forEach((el) => {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      el.style.display = 'none';
    });
  });
})();
